export const WebRoutes = {
    ALL_APPOINTMENTS: '/appointments',
    APPOINTMENT_DETAILS: '/appointment/:id',
    APPOINTMENT_RATING: '/appointment-rating',
    REQUEST_CALL: '/request-call',
    BOOKING_STEP_ONE:'/book-doctor/step-1',
    QUERIES:'/queries',
    QUERY_DETAILS:'/queries/:id',
    QUERY_FEEDBACK:'/queries-feedback',
}